import React, { useState } from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import DefaultButton from 'components/Utils/NewDefaultButton';
import PerformanceUtils from 'services/PerformanceUtils';
import { useAppDispatch } from 'careand-redux/useAppDispatch';
import { api } from 'careand-redux/api/ApiThunks';

const FIELDS = ['name', 'contact', 'relation'];

const EmergencyContactDetails = ({ patient }) => {
  const dispatch = useAppDispatch();

  const [value, setValue] = useState(patient.emergency_contact || {});
  const [loading, setLoading] = useState(false);

  async function saveContact() {
    setLoading(true);
    await dispatch(
      api.Patients.updatePatient({
        id: patient.id,
        patient: { ...patient, emergency_contact: value },
      }),
      {
        errorTitle: 'Emergency Contact',
      },
    );
    setLoading(false);
  }

  function onEmergencyContactChange(event) {
    setValue((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
  }

  return (
    <div className="emergency-details row full-width">
      <div className="row">
        {FIELDS.map((field) => (
          <DefaultTextField
            key={field}
            label={PerformanceUtils.capitalizeFirstLetter(field)}
            style={{ width: '100%' }}
            name={field}
            onChange={onEmergencyContactChange}
            value={value[field] || ''}
          />
        ))}
      </div>
      <DefaultButton name="Save" onClick={saveContact} loading={loading} className="padded" />
    </div>
  );
};

EmergencyContactDetails.propTypes = {
  patient: PropTypes.object.isRequired,
};

export default EmergencyContactDetails;
